import React, {Component} from 'react';
import Label from "./label";
import {List, Picker} from 'antd-mobile';
import IDataEntry from "./IDataEntry";
import BaseServer from "../../services/BaseServers";


class TimeSelect extends Component {

    state = {
        value: this.props.field_value
    };

    constructor(props) {
        super(props);
        
        const timeStyle = this.props.time_style;
        const isHourMinuteOnly = timeStyle === 1;

        this.hours = Array.from({ length: 24 }, (_, i) => ({
            label: i.toString().padStart(2, '0'),
            value: i.toString().padStart(2, '0')
        }));

        this.minutesSeconds = Array.from({ length: 60 }, (_, i) => ({
            label: i.toString().padStart(2, '0'),
            value: i.toString().padStart(2, '0')
        }));

        this.pickerData = isHourMinuteOnly 
            ? [this.hours, this.minutesSeconds] 
            : [this.hours, this.minutesSeconds, this.minutesSeconds];
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.field_value != this.state.value) {
            this.setState({value: nextProps.field_value});
        }
    }

    onChange = (value) => {
        const isHourMinuteOnly = this.props.time_style === 1;
        let v = isHourMinuteOnly && value.length > 2 
            ? value.slice(0, 2).join(':') 
            : value.join(':');       
        this.props.onFieldChange(v, this.props.field_key);
        this.setState({value: v});
    }

    getTimeArray(time) {
        const isHourMinuteOnly = this.props.time_style === 1;
        
        if (time && time.indexOf(":") > 0) {
            let timeArr = time.split(":");
            if (timeArr.length === 2) {
                timeArr.push('00');
            }
            let result = timeArr.map(t => t.padStart(2, '0'));
            return result;
        }
        return isHourMinuteOnly ? ['00', '00'] : ['00', '00', '00'];
    }

    render() {
        const timeArray = this.getTimeArray(this.state.value);
        const isHourMinuteOnly = this.props.time_style === 1;
        const displayTimeArray = isHourMinuteOnly ? timeArray.slice(0, 2) : timeArray;
        return (
            <List className="enroll-label" renderHeader={() => <Label {...this.props} />}>
                <Picker
                    data={this.pickerData}
                    title={this.props.field_name}
                    cascade={false}
                    extra="请选择"
                    disabled={this.props.disabled}
                    value={displayTimeArray}  
                    format={() => {     
                        return this.state.value || '';                     
                    }}            
                    onChange={this.onChange}
                    onOk={this.onChange}
                >
                    <List.Item arrow="horizontal">
                        {this.props.field_name}                        
                    </List.Item>
                </Picker>
            </List>
        );
    }
}

TimeSelect.propTypes = IDataEntry;

export default TimeSelect;